export default __webpack_public_path__ + "static/media/Point-90.a617a329.svg";